<template>
 <div>
    <loader :show="enviando"/>
    <b-modal  v-model="mostrar" size="xs" title="Expediente" hide-footer  hide-header-close no-close-on-backdrop>
    
    <b-card-body>
    <b-row>
      <b-col v-if ="!editarExpediente" sm="12"> <h4 style="text-align: center">Nuevo expediente</h4> </b-col>
      <b-col v-else sm="12"> <h4 style="text-align: center">Expediente {{editarExpediente.folio}}</h4> </b-col>
      <b-col md="12">
        <b-form-group >
          <label>Folio de pago de Tesoreria</label>
          <b-form-input           
            v-model="expediente.folioTesoreria"
            placeholder="Nombre"
            :class="{invalid_input: $v.expediente.folioTesoreria.$error}"
          ></b-form-input>
          <label v-if="$v.expediente.folioTesoreria.$error && !$v.expediente.folioTesoreria.required" class="error-text" >
            <i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>
          <b-col md="12">
        <b-form-group >
          <label>Tipo de solicitud</label>
          <b-form-select v-model="expediente.tipoSolicitud" :options="solicitudes" class="mb-3"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group >
          <label>Fecha de solicitud</label>
          <b-form-input           
            v-model="expediente.fechaSolicitud"
            type="date"
          ></b-form-input>
        </b-form-group>
      </b-col>
       <b-col md="12">
        <b-form-group >
          <label  >Fecha de pago</label>
          <b-form-input           
            v-model="expediente.fechaPago"
            type="date"
           
          ></b-form-input>
          
        </b-form-group>
      </b-col>
   
   
    </b-row>

    <b-row>      
      <b-col style="text-align: center">
        <b-button @click="$emit('cancelar')" :disabled="enviando">Cancelar</b-button>
        <br />
      </b-col>
      <b-col style="text-align: center">
        <b-button variant="primary" @click="guardar()" :disabled="enviando">Guardar cambios</b-button>
      </b-col>
     
    </b-row>
    </b-card-body>
    </b-modal>

  </div>
</template>

<script>
import axios from "axios";
import Loader from "../Loader";
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
const { DateTime } = require("luxon");
export default {
  name: "formExpediente",
  components: { Loader },
  props: ["mostrar", "editarExpediente", 'idCuenta'],
  computed: {
    ...mapGetters(["httpURL", "sessionToken"]),
    
  },
  validations: { expediente:{folioTesoreria:{required }}},
  data: function() {
    return {
      enviando: false,    
      expediente:{
        tipoSolicitud:null,
        folioTesoreria:'',
        fechaSolicitud: DateTime.now().toFormat('yyyy-MM-dd'),
        fechaPago: DateTime.now().toFormat('yyyy-MM-dd'),
      },
       solicitudes:[
        'NORMA 02',
        'PROGRAMA INTERNO P.C.',
        'ESTUDIO DE RIESGO',
        'HABITABILIDAD',
        'REVISIÓN DE MEDIDAS DE SEGURIDAD'
        ],
    
    };
  },
  mounted(){
     if(this.editarExpediente){
      this.expediente =  {
        tipoSolicitud :this.editarExpediente.tipoSolicitud,
        folioTesoreria:this.editarExpediente.folioTesoreria,
        fechaSolicitud : DateTime.fromISO(this.editarExpediente.fechaSolicitud).toFormat('yyyy-MM-dd'),
        fechaPago : DateTime.fromISO(this.editarExpediente.fechaPago).toFormat('yyyy-MM-dd'), 
      }
     }
     else this.expediente.tipoSolicitud = this.solicitudes[0];
  },
  methods: {
 
    guardar(){
      this.$v.$touch();
        
      if (!this.$v.$invalid) {
        this.enviando=true;
        if(!this.editarExpediente){
          
          axios.post(this.httpURL+'/proteccionBomberos/cuenta/'+this.idCuenta+'/expediente',
              {...this.expediente},
              {headers: {token:this.sessionToken}})
          .then(res => {
              this.enviando=false;
              if(res.data.ok){
              this.$emit('guardar',res.data.expediente);
              this.$emit('cancelar');
              this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000, text: res.data.mensaje })
              }
          })
          .catch(error => {
            
              this.enviando=false;
              if(error.response){
                  //console.log(error.response);
                  this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000, text: error.response.data.mensaje });
              }else if( error.request){
                  this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000, text: 'No se pudo establecer una conexión al servidor.' });
              }
          });
        }else{
        
          axios.put(this.httpURL+'/proteccionBomberos/cuenta/'+this.idCuenta+'/expediente/'+this.editarExpediente._id,
              {...this.expediente},
              {headers: {token:this.sessionToken}})
          .then(res => {
            //console.log(res.data);
              this.enviando=false;
              if(res.data.ok){
              this.$emit('actualizar',res.data.expediente);
              this.$emit('cancelar');
              this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000, text: res.data.mensaje })
              }
          })
          .catch(error => {
            //console.log(error);
              this.enviando=false;
              if(error.response){
                  //console.log(error.response);
                  this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000, text: error.response.data.mensaje });
              }else if( error.request){
                  this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000, text: 'No se pudo establecer una conexión al servidor.' });
              }
          });
        }
        
      }

    }
   
  }
};
</script>

<style >
.error-text {
  color: #ff0000;
}
.invalid_input{
    border: 1px solid red;
}

</style>
